<template>
  <v-container fluid>
    <template>
      <v-card class="mt-4">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="4">
              <v-autocomplete
                v-model="name"
                :items="nameSel()"
		item-text="distributor.name"
		item-value="distributor.name"
                label="Όνομα"
                prepend-icon="mdi-account"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2">
              <v-autocomplete
                v-model="afm"
                :items="uniq(invoices, 'Issuer').sort()"
                label="ΑΦΜ"
                prepend-icon="mdi-account"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="2">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  label="Ημερομηνίες"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filter_dates"
                @input="menu = false"
                range
                event-color="orange lighten-1"
                :events="functionEvents"
                :max="
                  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
                "
              ></v-date-picker>
            </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>

  <template>
  <v-card class="ma-0 mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Παραστατικά</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      height=670
      :headers="headers"
      :items="invoices"
      :search="search"
      sort-by="Date"
      sort-desc
      item-key="Mark"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
      show-group-by
      show-select
      @item-selected="itemSelected"
      @toggle-select-all="itemSelectAll"
      :footer-props="footerProps"

    >
<template v-slot:top>
      <v-toolbar
        flat
      >
        <v-spacer></v-spacer>
            <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="copyItems"
            >
              Αντιγραφή παραστατικών
            </v-btn>
      </v-toolbar>
  </template>
     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          :to="'/quote/'+item.quoteid+'/edit'"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
        <v-tooltip top
          :value="showTool(item)"
          >
      <template v-slot:activator="{ on, attrs }">
       <!-- <v-btn
          v-bind="attrs"
          icon
          @click="copyToClip(item)"
        >
         <v-icon>mdi-content-paste</v-icon>
        </v-btn> -->
         <v-btn
          v-bind="attrs"
          icon
          @click.stop="createInvoice(item)"
          >
         <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </template>
      <span>Αντιγράφηκε</span>
    </v-tooltip>
     </template>

    <template v-slot:item.NetValue="{ item }">
       {{ tocurr(item.NetValue) }}
    </template>
     <template v-slot:item.Supplier.Name="{ item }">
       {{ item.Supplier.Name }} 
       <v-btn icon small :to="{name: 'distributor-invoices', params: {id: item.Supplier.Id}}">
         <v-icon small>mdi-information-variant</v-icon></v-btn>
    </template>
    <template v-slot:item.TotalValue="{ item }">
       {{ tocurr(item.TotalValue) }}
    </template>
    <template v-slot:item.VatValue="{ item }">
       {{ tocurr(item.VatValue) }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.Mark }}
      </td>
    </template>
        <template v-slot:foot="{ items }">
          <td colspan="8"></td>
          <td colspan="4">
            Σύνολο:
            {{
              tocurr(sumField(items, "TotalValue"))
            }}
          </td>
        </template>

    </v-data-table>
  </v-card>
</template>
  <v-snackbar
   timeout=2500
   v-model="snackbar"
   multi-line=true>
      {{ snackText }}
  </v-snackbar>
  </v-container>
</template>

<script>

String.prototype.format = function () {
  // store arguments in an array
  var args = arguments;
  // use replace to iterate over the string
  // select the match and check if related argument is present
  // if yes, replace the match with the argument
  return this.replace(/{([0-9]+)}/g, function (match, index) {
    // check if the argument is present
    return typeof args[index] == 'undefined' ? match : args[index];
  });
};


String.prototype.format = function( params ) {
  return this.replace(
    /\{(\w+)\}/g,
    function( a,b ) { return params[ b ]; }
  );
};

import { uniqBy as _uniqBy } from 'lodash';
import { clone as _clone } from 'lodash'

export default {
  components: {
  },
  props: {
    invoices: {required: true, type: Array},
    loading: {default: true},
    own: {default: false},
  },
  computed: {
      dateRangeText () {
        return this.filter_dates.join(' ~ ')
      },
  },
  data() {
    return {
      footerProps: {
        "items-per-page-options": [10,25,50,100, -1],
      },
      menu: false,
      expanded: [],
      toolmark: null,
      tocopy: {},
      dialog: false,
      balance: 0.0,
      afm: '',
      name: '',
      vehicle: [],
      filter_dates: [],
      search: '',
      snackbar: false,
      snackText: "",
      invoiceForm: {
            SeriesCode: '',
            DocNumber: 0,
            InvoiceType: '1.1',
            Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            Remarks: null,
            PaymTerm: 5,
            NetValue: 0,
            VatValue: 0,
            TotalValue: 0,
            Kind: 0
      },
      headers: [
          {
            text: 'ΜΑΡΚ',
            align: 'start',
            //sortable: false,
            value: 'Mark',
            width: '10%',
          },
          { text: 'ΑΦΜ', value: 'Issuer', width: '10%',
          filter: (value) => {
            if (!this.afm) return true;
            return value == this.afm;
            },
          },
          { text: 'Όνομα', value: 'Supplier.Name', width: '15%',
          filter: (value) => {
            if (!this.name) return true;
            return value == this.name;
            },
          },
          { text: 'Ημερομηνία', value: 'Date', width: '10%',
            filter: (value) => {

              this.filter_dates.sort();
              if (this.filter_dates == 0) return true;
              if (this.filter_dates.length == 1) return value == this.filter_dates[0];
              if (this.filter_dates.length == 2) {
                return  this.checkDates(value);
              }
            },
          },
          { text: 'Τιμολόγιο', value: 'InvoiceId', align: 'center', groupable: false },
          { text: 'Τύπος', value: 'InvoiceType.Desc', align: 'left', groupable: false },
          { text: 'Τρόπος πληρωμής', value: 'PaymTerm.Desc', align: 'left', groupable: false },
          { text: 'Καθαρή αξία', value: 'NetValue', align: 'end', groupable: false },
          { text: 'ΦΠΑ', value: 'VatValue', align: 'end' , groupable: false},
          { text: 'Συνολο', value: 'TotalValue', align: 'end', groupable: false },
          { text: 'Actions', value: 'actions', groupable: false },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
    if (this.own) {
      this.headers[1].value = 'Counterpart';
      this.headers[2].value = 'Customer.Name';
    }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  checkDates (date) {
    let d = new Date(date).getTime();
    let f = new Date(this.filter_dates[0]).getTime();
    let t = new Date(this.filter_dates[1]).getTime();
    console.log(d, f, t)
    if (d >= f && d <= t) return true;
    return false;
  },
  functionEvents (date) {
    return this.invoices.some(e => e.date == date);
  },
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  close () {
        this.timdialog = false
  },
  tocurr(value) {
    return new Intl.NumberFormat("el-GR", {
      style: "currency",
      currency: "EUR",
    }).format(value.toFixed(2));
  },

  sumField(items, key) {
    // sum data in give key (property)
    return items.reduce((a, b) => a + (b[key] || 0), 0);
  },
  uniq(items, key) {
    //Store the unique
    let uniques = [];

    //Track the items added to the uniques
    let itemsFound = {};
    for (let val of items) {
      //If item is already added then move to the next item
      if (itemsFound[val[key]]) {
        continue;
      }

      //Else push it to the unique list
      uniques.push(val[key]);

      //Mark it as added
      itemsFound[val[key]] = true;
    }

    //Return the uniques
    return uniques;
  },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },
  itemSelected(selected) {
    if (selected.value) {
      this.tocopy[selected.item.Mark] = this.parseItem(selected.item);
    } else {
      delete this.tocopy[selected.item.Mark];
    }
  },
  itemSelectAll(selected) {
    if (selected.value) {
      for (let item in selected.items) {
        this.tocopy[item.Mark] = item;
      }
    } else {
      this.tocopy = {}
    }
  },
  nameSel() {
    var names =  _uniqBy(this.invoices, 'Supplier.name').sort()
    if (this.own) {
      names = _uniqBy(this.invoices, 'Customer.name').sort()
    }
     console.log(names);
     return names;
  },
  showTool(item) {
    return this.toolmark == item.Mark;
  },
  copyTimedOut() {
    this.toolmark = null;
  },
  parseItem(item) {
    let type = item.InvoiceType.Type;
    let name = item.Distributor.Name; //.split("||").pop();
    if (this.own) {
       name = item.Customer.Name;
    }
    let data = {
        date: item.date,
        invoid: item.InvoiceId,
        type: type,
        name: name,
        mark: item.Mark,
        invotype: item.InvoiceType.Desc,
        num: '=COUNTIF(INDIRECT("E2:E"&(ROW()));"="&INDIRECT("E"&ROW()))',
    }
    if (type == '1.1') {
      data["net"] = item.netvalue;
      data["vat"] = item.vatvalue;
      data["total"] = item.totalvalue;
      data["typecode"] = 102;
    } else if (type == '2.1') {
      data["net"] = item.netvalue;
      data["vat"] = item.vatvalue;
      data["total"] = item.totalvalue;
      data["typecode"] = 108;
    } else {
      data["net"] = -item.netvalue;
      data["vat"] = -item.vatvalue;
      data["total"] = -item.totalvalue;
      data["typecode"] = 107;
    }
    let text ='"{name}"\t{invoid}\t{date}\t"Κανονικό"\t{typecode}\t"{invotype}"\tΤΔΑ\t{num}\t{net}\t{vat}\t{total}\t{mark}\n'.format(data)
    return text;
  },
  
    async createInvoice(item) {
        let invoice = _clone(this.invoiceForm);
        invoice.PaymTerm = item.PaymTerm.Term;
        invoice.NetValue = item.NetValue;
        invoice.VatValue = item.VatValue;
        invoice.TotalValue = item.TotalValue;
        invoice.SeriesCode = item.SeriesCode;
        invoice.DocNumber = item.DocNumber;
        invoice.InvoiceType = item.InvoiceType.Type;
        invoice.Date = item.Date;
        invoice.Mark = item.Mark;
        var response = await this.$api.post("/suppliers/"+item.Supplier.Id+"/invoice/", invoice);
        if (response.status == 201) {
          // this.invoiceForm.Id = response.data.Id;
          this.snackText = `Αντιγραφηκε το τιμολόγιο ${item.SeriesCode}-${item.DocNumber}.\nΝέο υπόλοιπο: ${response.data.Supplier.Balance.toFixed(2)}€`;
          this.snackbar = true;
          
        } else {
          alert(response.data);
        }
      },
  
  
  copyItems() {
    let text = "Προμηθετής\tΠαραστατικό\tΗμερ/νία\tΚατάσταση\tΚωδ. τύπου\tΤύπος παρ/κού\tΑιτιολογία\tΑριθμός\tΚαθαρή αξία\tΑξία ΦΠΑ\tΣύνολο Αξίας\tΑΑΔΕ ΜΑΡΚ\n";

    for (let k in this.tocopy) {
      text += this.tocopy[k];
    }
    navigator.clipboard.writeText(text);
        alert("Η γραμμή αντιγράφηκε στο πρόχειρο.");
  },
  copyToClip(item) {
    let header = "Προμηθετής\tΠαραστατικό\tΗμερ/νία\tΚατάσταση\tΚωδ. τύπου\tΤύπος παρ/κού\tΑιτιολογία\tΑριθμός\tΚαθαρή αξία\tΑξία ΦΠΑ\tΣύνολο Αξίας\tΑΑΔΕ ΜΑΡΚ\n";
    let text = header + this.parseItem(item);
    navigator.clipboard.writeText(text);
    this.toolmark = item.Mark;
    setTimeout(this.copyTimedOut, 1000);
  },

  }
}
</script>
